<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#004889">
            <v-card flat color="#004889">
                <v-card-text class="pa-0">
                    <v-form ref="jobDetailsForm">
                        <v-list flat color="#004889" class="py-0">
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Admin</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="form.users.admin"
                                        :items="users"
                                        item-text="name"
                                        item-value="id"
                                        label="Admin"
                                        clearable
                                        @change="submit"
                                        solo
                                        flat
                                        dark
                                        hide-details
                                        :readonly="userRole == 'finishing_crew'"
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Foreman</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="form.users.foreman"
                                        :items="users"
                                        item-text="name"
                                        item-value="id"
                                        label="Foreman"
                                        clearable
                                        @change="submit"
                                        solo
                                        flat
                                        dark
                                        hide-details
                                        :readonly="userRole == 'finishing_crew'"
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Sales Person</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="form.users.salesperson"
                                        :items="users"
                                        item-text="name"
                                        item-value="id"
                                        label="Salesperson"
                                        clearable
                                        @change="submit"
                                        solo
                                        flat
                                        dark
                                        hide-details
                                        :readonly="userRole == 'finishing_crew'"
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Technician</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="form.users.technician"
                                        :items="users"
                                        item-text="name"
                                        item-value="id"
                                        label="Technician"
                                        clearable
                                        @change="submit"
                                        solo
                                        flat
                                        dark
                                        hide-details
                                        :readonly="userRole == 'finishing_crew'"
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Cleaner</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="form.users.cleaner"
                                        :items="users"
                                        item-text="name"
                                        item-value="id"
                                        label="Cleaner"
                                        clearable
                                        @change="submit"
                                        solo
                                        flat
                                        dark 
                                        hide-details
                                        color="secondary"
                                        :readonly="userRole == 'finishing_crew'"
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-form>
                </v-card-text> 
            </v-card>
            <Drawer :show="drawer" :id="id" :cid.sync="customer" @update-drawer="updateDrawer" />
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import Drawer from './Drawer.vue'
    import { mapGetters, mapActions } from 'vuex'
    import authmixin from '../../mixin/auth.js'

    export default {
        mixins: [authmixin],
        props: ['id'],
        data () {
            return {
                form: {
                    users: {
                        admin: '',
                        foreman: '',
                        salesperson: '',
                        technician: '',
                        cleaner: ''
                    },
                },
                customer: '',
                loading: false,
                token: '',
                pageTitle: '',
                drawer: false,
            }
        },
        created() {
            this.getAssignees()
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        components: {
            Drawer,
        },
        computed: {
            ...mapGetters({
                users: 'data/users',
            }),
        },
        methods: {
            ...mapActions({
                updateAssignees: 'data/updateAssignees',
            }),
            getAssignees() {
                if(this.id) {
                    this.loading = true
                    axios.get('crm/job/assignees?id=' + this.id)
                        .then((response) => {
                            this.loading = false
                            this.form.users = response.data.users
                            if(response.data.users == null) {
                                this.form.users = {
                                    admin: '',
                                    foreman: '',
                                    salesperson: '',
                                    technician: '',
                                    cleaner: ''                                
                                }
                            }
                            this.customer = response.data.customer
                            this.$nextTick()
                        })
                }
            },
            async submit() {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateAssignees(this.form).then(() => {
                    this.getAssignees()
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            },
            updateDrawer(val) {
                this.drawer = val
            },
        }
    }
</script>

<style lang="sass">
.v-list-item__content
    &.label
        width: 35%

        + .v-list-item__action
            width: 65%

            > span 
                width: 100%

.theme--dark.v-text-field--solo
    > .v-input__control
        > .v-input__slot
            background: #003a6f!important
            border-radius: 0

.form-row
    background: #1565c0
    margin-bottom: 2px
</style>
